import { createRequestTypes } from '../utils';

export const TOXPROFILEITEM_LIST = createRequestTypes('ToxProfileItem/TOXPROFILEITEM_LIST');
export const SAVE_TOXPROFILEITEM = createRequestTypes('ToxProfileItem/SAVE_TOXPROFILEITEM');
export const DELETE_TOXPROFILEITEM = createRequestTypes('ToxProfileItem/DELETE_TOXPROFILEITEM');
